const e = "styles-module__extras_wrapper___4mVqg", r = {
  extras_wrapper: e
};
export {
  r as default,
  e as extras_wrapper
};
